'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    .col-xs-6 {\n      max-width: 100%;\n      flex-basis: 100%;\n    }\n  '], ['\n    .col-xs-6 {\n      max-width: 100%;\n      flex-basis: 100%;\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _AddOnItem = require('./optional-items/AddOnItem');

var _AddOnItem2 = _interopRequireDefault(_AddOnItem);

var _UIGrid = require('UIComponents/grid/UIGrid');

var _UIGrid2 = _interopRequireDefault(_UIGrid);

var _AccordionTransition = require('UIComponents/transitions/AccordionTransition');

var _AccordionTransition2 = _interopRequireDefault(_AccordionTransition);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _H = require('UIComponents/elements/headings/H1');

var _H2 = _interopRequireDefault(_H);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledH1 = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'AddOns__StyledH1'
})(['margin-bottom:8px !important;']);

var ButtonGrid = (0, _styledComponents2.default)(_UIGrid2.default).withConfig({
  displayName: 'AddOns__ButtonGrid'
})(['', ';'], _responsiveBreakpoints2.default.tablet(_templateObject));

function AddOns(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var stringKey = isOpen ? 'seeFewer' : 'seeMore';

  return _react2.default.createElement(
    'div',
    { className: 'm-bottom-12' },
    _react2.default.createElement(
      StyledH1,
      null,
      title
    ),
    subtitle,
    _react2.default.createElement(
      ButtonGrid,
      { className: 'm-top-4' },
      _react2.default.createElement(_AddOnItem2.default, { merchandiseId: _MerchandiseIds.ADDON_CMS }),
      _react2.default.createElement(_AddOnItem2.default, { merchandiseId: _MerchandiseIds.ADDON_REPORTING }),
      _react2.default.createElement(_AddOnItem2.default, { merchandiseId: _MerchandiseIds.ADDON_ADS }),
      _react2.default.createElement(_AddOnItem2.default, { merchandiseId: _MerchandiseIds.ADDON_DEDICATED_IP })
    ),
    _react2.default.createElement(
      _AccordionTransition2.default,
      { open: isOpen },
      _react2.default.createElement(
        ButtonGrid,
        null,
        _react2.default.createElement(_AddOnItem2.default, { merchandiseId: _MerchandiseIds.ADDON_TRANSACTIONAL_EMAIL }),
        _react2.default.createElement(_AddOnItem2.default, { merchandiseId: _MerchandiseIds.ADDON_CUSTOM_SSL }),
        _react2.default.createElement(_AddOnItem2.default, { merchandiseId: _MerchandiseIds.ADDON_API }),
        _react2.default.createElement(_AddOnItem2.default, { merchandiseId: _MerchandiseIds.ADDON_BRAND_DOMAIN })
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'text-center m-top-2' },
      _react2.default.createElement(
        _UILink2.default,
        { onClick: function onClick() {
            return setIsOpen(!isOpen);
          } },
        _react2.default.createElement(_FormattedMessage2.default, {
          message: 'pricingPage.calculator.addonsAndServices.addons.' + stringKey
        })
      )
    )
  );
}
exports.default = AddOns;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/AddOns.js
// module id = 716
// module chunks = 3 4